import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestZulassungService } from '@app/core/api/zulassung.service';
import { ActiveZulassungQuery } from '@app/core/state/active-zulassung/active-zulassung.query';
import { ActiveZulassungStore } from '@app/core/state/active-zulassung/active-zulassung.store';
import { PayloadUtil } from '@app/core/util/payload.util';
import { ZulassungResult } from '@pezi/entities';
import { Subscription, take } from 'rxjs';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ActiveZulassungService {

  private subscription: Subscription;

  constructor(private activeZulassungStore: ActiveZulassungStore,
              private activeZulassungQuery: ActiveZulassungQuery,
              private zulassungService: RestZulassungService,
              private snackBar: MatSnackBar) {
  }


  initZulassung(id: number, index: number) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activeZulassungStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeZulassungStore.data.getValue();
    if (!id || !index) {
      this.clearStore();
    } else {
      if (!currentState.zulassung || currentState.zulassung.zulId !== +id || currentState.zulassung.index !== +index ) {

        this.activeZulassungStore.data.reset();
        this.activeZulassungStore.data.update(setProps({
          loading: true
        }));
        this.subscription = this.zulassungService.getZulassungForId(id, index).pipe(
          take(1),
        ).subscribe(result => {
          let zulassung: ZulassungResult;
          let errorLoadingZulassung = false;
          if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
            'Fehler: Zulassung konnte nicht geladen werden')) {
            zulassung = result.data;
          } else {
            errorLoadingZulassung = true;
          }
          this.activeZulassungStore.data.update(setProps({
            loading: false, errorLoading: errorLoadingZulassung, zulassung
          }));
        });
      }
    }
  }

  clearStore() {
    this.activeZulassungStore.data.reset();
  }
}
